import { mapState } from "vuex";
import { appltIndexMixins } from "@/mixins/appltIndexMixins";
import { goodsIndexMixins } from "@/mixins/goodsIndexMixins";
import { orderIndexMixins } from "@/mixins/orderIndexMixins";
import { groupPurchaseIndexMixins } from "@/mixins/groupPurchaseIndexMixins";
import { dataIndexMixins } from "@/mixins/dataIndexMixins";
import { vipIndexMixins } from "@/mixins/vipIndexMixins";
import { equityCardIndexMixins } from "@/mixins/equityCardIndexMixins";
import { cardCouponIndexMixins } from "@/mixins/cardCouponIndexMixins";
import { shopIndexMixins } from "@/mixins/shopIndexMixins";
import { commentIndexMixins } from "@/mixins/commentIndexMixins";
import { msgIndexMixins } from "@/mixins/msgIndexMixins";
import { payManageIndexMixins } from "@/mixins/payManageIndexMixins";
import { distributionIndexMixins } from "@/mixins/distributionIndexMixins";
import { settingIndexMixins } from "@/mixins/settingIndexMixins";
import { oilGunIndexMixins } from "@/mixins/oilGunIndexMixins";
import { serviceIndexMixins } from "@/mixins/serviceIndexMixins";
import { tableIndexMixins } from "@/mixins/tableIndexMixins";
import { bookingIndexMixins } from "@/mixins/bookingIndexMixins";
import { craftsmanIndexMixins } from "@/mixins/craftsmanIndexMixins";
import { shopsIndexMixins } from "@/mixins/shopsIndexMixins";
import { realTimeInfoIndexMixins } from "@/mixins/realTimeInfoIndexMixins";
import { marketingIndexMixins } from "@/mixins/marketingIndexMixins";
import { queueIndexMixins } from "@/mixins/queueIndexMixins";
import { invoicingIndexMixins } from "@/mixins/invoicingIndexMixins";
import { deviceManageIndexMixins } from "@/mixins/deviceManageIndexMixins";
export const menuListMixins = {
  mixins: [
    appltIndexMixins,
    goodsIndexMixins,
    orderIndexMixins,
    groupPurchaseIndexMixins,
    dataIndexMixins,
    vipIndexMixins,
    equityCardIndexMixins,
    cardCouponIndexMixins,
    shopIndexMixins,
    commentIndexMixins,
    msgIndexMixins,
    payManageIndexMixins,
    distributionIndexMixins,
    settingIndexMixins,
    oilGunIndexMixins,
    serviceIndexMixins,
    tableIndexMixins,
    bookingIndexMixins,
    craftsmanIndexMixins,
    shopsIndexMixins,
    realTimeInfoIndexMixins,
    marketingIndexMixins,
    queueIndexMixins,
    invoicingIndexMixins,
    deviceManageIndexMixins,
  ],
  data() {
    return {
      colorClass: ["rgba(64, 158, 255, 1)", "rgba(103, 194, 58, 1)", "rgba(255, 165, 30, 1)", "rgba(245, 116, 116, 1)"],
    }
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      oemInfo: (state) => state.oemInfo,
      isOwn: (state) => state.isOwn,
      oemInstitution: (state) => state.oemInstitution,
    }),
    menuList() {
      // let isMaster = localStorage.userType == 101;
      let isMaster = this.shopInfo.isMaster;
      let menuList = [];
      let menuMap = {
        home: {
          name: "首页概况",
          icon: "computer",
          isActive: false,
          path: "/",
          children: [],
        },
        applt: {
          name: "小程序",
          icon: "weibiaoti",
          isActive: false,
          path: "/applt",
          children: this.appltTopBarList,
        },
        goods: {
          name: "商品管理",
          icon: "shopping",
          isActive: false,
          path: "/goods",
          children: this.goodsTopBarList,
        },
        order: {
          name: "订单管理",
          icon: "task",
          isActive: false,
          path: "/order",
          children: this.orderTopBarList,
        },
        groupPurchase: {
          name: "营销活动",
          icon: "activity",
          isActive: false,
          path: "/groupPurchase",
          children: this.groupPurchaseTopBarList,
        },
        data: {
          name: "数据中心",
          icon: "data",
          isActive: false,
          path: "/data",
          children: this.dataTopBarList,
        },
        vip: {
          name: "会员管理",
          icon: "user",
          isActive: false,
          path: "/vip",
          children: this.vipTopBarList,
        },
        equityCard: {
          name: "权益卡管理",
          icon: "quanyiqia",
          isActive: false,
          path: "/equityCard",
          children: this.equityCardTopBarList,
        },
        cardCoupon: {
          name: "优惠券管理",
          icon: "huiyuanqia",
          isActive: false,
          path: "/cardCoupon",
          children: this.cardCouponTopBarList,
        },
        shop: {
          name: "门店管理",
          icon: "house",
          isActive: false,
          path: "/shop",
          children: this.shopTopBarList,
        },
        comment: {
          name: "评论管理",
          icon: "like",
          isActive: false,
          path: "/comment",
          children: this.commentTopBarList,
        },
        msg: {
          name: "消息管理",
          icon: "msg",
          isActive: false,
          path: "/msgManage",
          children: this.msgTopBarList,
        },
        payManage: {
          name: "缴费管理",
          icon: "wallet",
          isActive: false,
          path: "/paymanage",
          children: this.payManageTopBarList,
        },
        distribution: {
          name: "分销管理",
          icon: "distribution",
          isActive: false,
          path: "/distribution",
          children: this.distributionTopBarList,
        },
        setting: {
          name: "设置中心",
          icon: "setting",
          isActive: false,
          path: "/setting",
          children: this.settingTopBarList,
        },
        settingDsShop: {
          name: "设置中心",
          icon: "setting",
          isActive: false,
          path: "/settingDsShop",
          children: this.settingTopBarList,
        },
        oilGun: {
          name: "油枪管理",
          icon: "sofa",
          isActive: false,
          path: "/oilGun",
          children: this.oilGunTopBarList,
        },
        service: {
          name: "服务管理",
          icon: "fuwuguanli",
          isActive: false,
          path: "/service",
          children: this.serviceTopBarList,
        },
        table: {
          name: "桌位管理",
          icon: "sofa",
          isActive: false,
          path: "/table",
          children: this.tableTopBarList,
        },
        booking: {
          name: "预约管理",
          icon: "yuyuedingdan",
          isActive: false,
          path: "/booking",
          children: this.bookingTopBarList,
        },
        craftsman: {
          name: "预约设置",
          icon: "yuyuefuwu",
          isActive: false,
          path: "/craftsman",
          children: this.craftsmanTopBarList,
        },
        shops: {
          name: "商铺管理",
          icon: "shangpu",
          isActive: false,
          path: "/shops",
          children: this.shopsTopBarList,
        },
        realTimeInfo: {
          name: "资讯管理",
          icon: "zixun",
          isActive: false,
          path: "/realTimeInfo",
          children: this.realTimeInfoTopBarList,
        },
        marketing: {
          name: "营销管理",
          icon: "set",
          isActive: false,
          path: "/marketing",
          children: this.marketingTopBarList,
        },
        queue: {
          name: "排队叫号",
          icon: "bell",
          isActive: false,
          path: "/queue",
          children: this.queueTopBarList,
        },
        invoicing: {
          name: "进销存管理",
          icon: "zixun",
          isActive: false,
          path: "/invoicing",
          children: this.invoicingTopBarList,
        },
        devicemanage: {
          name: "终端管理",
          icon: "device",
          isActive: false,
          path: "/devicemanage",
          children: this.deviceManageTopBarList,
        },
      };

      console.log(99, this.shopInfo.edcShopType, this.isOwn, isMaster, menuMap);
      if (this.shopInfo.edcShopType == 2) {
        menuList = [
          menuMap["home"],
          menuMap["applt"],
          menuMap["goods"],
          menuMap["order"],
          menuMap["groupPurchase"],
          menuMap["data"],
          menuMap["vip"],
          menuMap["equityCard"],
          menuMap["cardCoupon"],
          menuMap["shop"],
          menuMap["devicemanage"],
          menuMap["comment"],
          menuMap["msg"],
          menuMap["payManage"],
          menuMap["distribution"],
          menuMap["setting"],
        ];
        if (!isMaster) {
          menuList = [
            menuMap["home"],
            menuMap["goods"],
            menuMap["order"],
            menuMap["groupPurchase"],
            menuMap["data"],
            menuMap["vip"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["devicemanage"],
            menuMap["comment"],
            menuMap["setting"],
          ];
        }
      } else if (this.shopInfo.edcShopType == 5) {
        menuList = [
          menuMap["home"],
          menuMap["applt"],
          menuMap["shop"],
          menuMap["oilGun"],
          menuMap["goods"],
          menuMap["order"],
          menuMap["data"],
          menuMap["vip"],
          menuMap["devicemanage"],
          menuMap["cardCoupon"],
          menuMap["groupPurchase"],
          menuMap["setting"],
        ];
        if (!isMaster) {
          menuList = [
            menuMap["home"],
            menuMap["applt"],
            menuMap["oilGun"],
            menuMap["goods"],
            menuMap["order"],
            menuMap["data"],
            menuMap["vip"],
            menuMap["devicemanage"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["setting"],
          ];
        }
      } else if (this.shopInfo.edcShopType == 8) {
        menuList = [
          menuMap["home"],
          menuMap["applt"],
          menuMap["goods"],
          menuMap["service"],
          menuMap["booking"],
          menuMap["order"],
          menuMap["groupPurchase"],
          menuMap["data"],
          menuMap["vip"],
          menuMap["equityCard"],
          menuMap["cardCoupon"],
          menuMap["distribution"],
          menuMap["devicemanage"],
          menuMap["comment"],
          menuMap["msg"],
          menuMap["settingDsShop"],
          menuMap["craftsman"],
        ];
        if (!isMaster) {
          menuList = [
            menuMap["home"],
            menuMap["applt"],
            menuMap["goods"],
            menuMap["service"],
            menuMap["booking"],
            menuMap["order"],
            menuMap["groupPurchase"],
            menuMap["data"],
            menuMap["vip"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["devicemanage"],
            menuMap["comment"],
            menuMap["msg"],
            menuMap["setting"],
            menuMap["craftsman"],
          ];
        }
      } else if (this.shopInfo.edcShopType == 14) {
        menuList = [
          menuMap["home"],
          menuMap["applt"],
          menuMap["goods"],
          menuMap["order"],
          menuMap["shops"],
          menuMap["realTimeInfo"],
          menuMap["groupPurchase"],
          menuMap["data"],
          menuMap["vip"],
          menuMap["equityCard"],
          menuMap["cardCoupon"],
          menuMap["shop"],
          menuMap["devicemanage"],
          menuMap["comment"],
          menuMap["msg"],
          menuMap["payManage"],
          menuMap["distribution"],
          menuMap["setting"],
        ];
        if (!isMaster) {
          menuList = [
            menuMap["home"],
            menuMap["goods"],
            menuMap["order"],
            menuMap["groupPurchase"],
            menuMap["data"],
            menuMap["vip"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["devicemanage"],
            menuMap["comment"],
            menuMap["settingDsShop"],
          ];
        }
      } else if (this.shopInfo.edcShopType == 4) {
        if (this.isOwn) {
          menuList = [
            menuMap["home"],
            menuMap["applt"],
            menuMap["goods"],
            menuMap["order"],
            menuMap["data"],
            menuMap["table"],
            menuMap["vip"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["shop"],
            menuMap["devicemanage"],
            menuMap["comment"],
            menuMap["payManage"],
            menuMap["distribution"],
            menuMap["queue"],
            menuMap["msg"],
            menuMap["groupPurchase"],
            menuMap["marketing"],
            menuMap["invoicing"],
            menuMap["setting"],
          ];
          if (!isMaster) {
            menuList = [
              menuMap["home"],
              menuMap["goods"],
              menuMap["order"],
              menuMap["data"],
              menuMap["table"],
              menuMap["vip"],
              menuMap["equityCard"],
              menuMap["cardCoupon"],
              menuMap["comment"],
              menuMap["devicemanage"],
              menuMap["payManage"],
              menuMap["queue"],
              menuMap["invoicing"],
              menuMap["setting"],
            ];
          }
        } else {
          menuList = [
            menuMap["home"],
            menuMap["applt"],
            menuMap["goods"],
            menuMap["order"],
            menuMap["data"],
            menuMap["table"],
            menuMap["vip"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["shop"],
            menuMap["devicemanage"],
            menuMap["comment"],
            menuMap["payManage"],
            menuMap["msg"],
            menuMap["groupPurchase"],
            menuMap["distribution"],
            menuMap["queue"],
            menuMap["invoicing"],
            menuMap["setting"],
          ];
          if (!isMaster) {
            menuList = [
              menuMap["home"],
              menuMap["goods"],
              menuMap["order"],
              menuMap["data"],
              menuMap["table"],
              menuMap["vip"],
              menuMap["equityCard"],
              menuMap["cardCoupon"],
              menuMap["devicemanage"],
              menuMap["comment"],
              menuMap["queue"],
              menuMap["invoicing"],
              menuMap["setting"],
            ];
          }
        }
      } else {
        if (this.isOwn) {
          menuList = [
            menuMap["home"],
            menuMap["applt"],
            menuMap["goods"],
            menuMap["order"],
            menuMap["data"],
            menuMap["table"],
            menuMap["vip"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["shop"],
            menuMap["devicemanage"],
            menuMap["comment"],
            menuMap["payManage"],
            menuMap["distribution"],
            menuMap["queue"],
            menuMap["msg"],
            menuMap["groupPurchase"],
            menuMap["marketing"],
            menuMap["setting"],
          ];
          if (!isMaster) {
            menuList = [
              menuMap["home"],
              menuMap["goods"],
              menuMap["order"],
              menuMap["data"],
              menuMap["table"],
              menuMap["vip"],
              menuMap["equityCard"],
              menuMap["cardCoupon"],
              menuMap["devicemanage"],
              menuMap["comment"],
              menuMap["payManage"],
              menuMap["queue"],
              menuMap["setting"],
            ];
          }
        } else {
          menuList = [
            menuMap["home"],
            menuMap["applt"],
            menuMap["goods"],
            menuMap["order"],
            menuMap["data"],
            menuMap["table"],
            menuMap["vip"],
            menuMap["equityCard"],
            menuMap["cardCoupon"],
            menuMap["shop"],
            menuMap["devicemanage"],
            menuMap["comment"],
            menuMap["payManage"],
            menuMap["msg"],
            menuMap["groupPurchase"],
            menuMap["distribution"],
            menuMap["queue"],
            menuMap["setting"],
          ];
          if (!isMaster) {
            menuList = [
              menuMap["home"],
              menuMap["goods"],
              menuMap["order"],
              menuMap["data"],
              menuMap["table"],
              menuMap["vip"],
              menuMap["equityCard"],
              menuMap["cardCoupon"],
              menuMap["devicemanage"],
              menuMap["comment"],
              menuMap["queue"],
              menuMap["setting"],
            ];
          }
        }
      }
      menuList.forEach((val) => {
        if (val.path != "/") {
          if (this.$route.path.indexOf(val.path) == 0) {
            val.isActive = true;
            this.pathActive = val.path;
          }
        } else {
          if (this.$route.path == val.path) {
            val.isActive = true;
            this.pathActive = val.path;
          }
          if (~this.$route.path.indexOf("home")) {
            menuList[0].isActive = true;
          }
        }
      });
      return menuList;
    },
  },
}
